var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dropdown',[_c('i',{staticClass:"el-icon-setting",staticStyle:{"margin-right":"15px"}}),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.exitHandler.apply(null, arguments)}}},[_vm._v("退出登录")])],1)],1),_c('span',[_vm._v("admin")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }